
import { canv } from '@/canv/global.js'
import { createTextPartByEntityType, isTextWidgetV2 } from "@/elements/text/textPartFactory";
import { drawRoundedRect, isOverRect } from '@/canv/utils.js'

export class cardWidgetStatusBarStatus {

    constructor(startX, startY, height) {
        this.startX = startX;
        this.startY = startY;
        this.height = height;
        this.width = 115; // подобрано, чтобы влезали все статусы

        this.textPart = createTextPartByEntityType("textWidgetV2");

        this.textPart.menuTextSize(18, true);

        this.updateCoords(this.startX, this.startY);
    }


    updateCoords(startX, startY) {
        this.startX = startX;
        this.startY = startY;

        this.updateTextPosition();
    }

    updateTextPosition() {
        if (isTextWidgetV2(this.textPart)) {
            this.textPart.menuTextAlign("center", true);
            this.textPart.startX = this.startX + this.width / 2 - this.textPart.width / 2;
            this.textPart.startY = this.startY + this.height / 2 - this.textPart.height / 2 + this.textPart.lineHeight;
        } else {
            this.textPart.startX = this.startX + this.width / 2 - this.textPart.width / 2;
            this.textPart.startY = this.startY + this.height / 2 - this.textPart.height / 2 + this.textPart.lines[0].textHeight;
        }
        this.textPart.updateDims();
    }

    setProgressData(progressData, smooth = true) {

        this.progressData = progressData;
        this.textPart.setText(this.progressData["title"]);
        this.textPart.menuTextColor(this.progressData["majorColor"], true, false);
        this.updateTextPosition();

        if (smooth) this.transitionCounter = this.transitionCounterConst;
    }



    // draw

    draw() {

        drawRoundedRect(this.startX, this.startY, this.width, this.height, 8);
        canv.ctx.strokeStyle = this.progressData["minorColor"];
        if (isOverRect(this.startX, this.startY, this.width, this.height)) {
            canv.ctx.strokeStyle = this.progressData["majorColor"];
        }
        canv.ctx.lineWidth = 2;
        canv.ctx.stroke(); // нужно, иначе checkbox будет больше по размеру

        let memGlobalAlpha = canv.ctx.globalAlpha;

        if (this.transitionCounter != 0) {
            let perc = 1 - this.transitionCounter / this.transitionCounterConst;
            canv.ctx.globalAlpha = perc;

            this.transitionCounter--;
            canv.redraw();
        }

        canv.ctx.fillStyle = this.progressData["minorColor"];
        canv.ctx.fill();

        this.textPart.draw();

        canv.ctx.globalAlpha = memGlobalAlpha;

        this.drawPoints();
    }

    drawPoints() {
        let padding = 5;
        let pointD = (this.height - 4 * padding) / 3;

        canv.ctx.lineWidth = 1;

        this.drawPoint(this.startX + this.width + padding, this.startY + padding, pointD, "todo");
        this.drawPoint(this.startX + this.width + padding, this.startY + pointD + 2 * padding, pointD, "progress");
        this.drawPoint(this.startX + this.width + padding, this.startY + 2 * pointD + 3 * padding, pointD, "done");

    }

    drawPoint(startX, startY, d, targetStatus) {

        canv.ctx.strokeStyle = "#ECECEC";
        if (this.progressData["name"] == targetStatus) {
            canv.ctx.strokeStyle = this.progressData["majorColor"];
            canv.ctx.fillStyle = this.progressData["majorColor"];
        }
        drawRoundedRect(startX, startY, d, d, d * 10);
        canv.ctx.stroke();

        if (this.progressData["name"] == targetStatus) {
            canv.ctx.fill();
        }
    }




    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    textPart = null;
    progressData = null;

    // transition
    transitionCounter = 0;
    transitionCounterConst = 20;
}











